<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FUNziZ/media/FC-9781398499096.jpg?1692049837834" alt="This image is the cover for the book Bird Wisdom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bird Wisdom
      </h1>
      <p class="bookDescription body article font2">
        <p>The fundamental themes of landscape, love and loss are all celebrated in this collection. Some of the poems have a political quality, reflecting the challenges and uncertainties of life in the 21st century; others simply honour the joy, the struggles, and the hopefulness of daily life. The poems encompass a wide genre, but all reflect a connection between people and place. Many celebrate the poet’s ‘home paddock’ while others look to the wider world. Though the inspiration is landscapes familiar to the author, the themes are universal and resonant.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Annie Villiers
      </h2>
      
      <p class="authorDescription body article">Annie Villiers lives and works in the Central Otago region of Aotearoa New Zealand.  She has previously published two poetry collections, both in collaboration with artist John Z Robinson, and a novel set in New Zealand and Greece.  Her writing reflects a deep sense of connection to the physical landscape and to the wider landscape of belonging; physical and metaphysical.  Her writing celebrates the whenua (land) the tangata (people) and the stories that connect them.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c8db28ca